const mainFilterCat = [
  {
    key: 'all',
    api: null,
  },
  {
    key: 'Approved',
    api: 1,
  },
  {
    key: 'Declined',
    api: 0,
  },
];

export default mainFilterCat;
